import React from 'react';
import { observer } from 'mobx-react';
import { DeckUI } from '@seedlang/state';
import styled from '@emotion/styled';
import Text from 'components/text';
import Button from 'components/button/button';
import { Theme } from '@seedlang/constants';
import { flexCenterColumn } from '@seedlang/style_mixins';
import { DeckCloseWebWrapper } from '@seedlang/hoc';
import Checkbox from 'components/checkbox';

const Wrapper = styled.div`
  ${flexCenterColumn()}
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  flex: 1;
  padding: 0 5px;
`;

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0 0 0;
`;

const CheckboxLabel = styled.div`
  cursor: pointer;
`;

@observer
class DeckClose extends React.Component {
  state = {
    disableFutureConfirmation: false,
  };

  onToggleDisableFutureConfirmation = () => {
    this.setState({
      disableFutureConfirmation: !this.state.disableFutureConfirmation,
    });
  }

  onConfirmCloseDeck = () => {
    this.props.onCloseDeck({
      bypassConfirmation: true,
      disableFutureConfirmation: this.state.disableFutureConfirmation,
    });
  }

  render() {
    return (
      <Wrapper>
        <Text
          heading='3'
          margin='0 0 20px 0'
        >
          Close this Deck?
        </Text>
        <ButtonGroup>
          <ButtonWrapper>
            <Button
              onClick={this.onConfirmCloseDeck}
              background={Theme.green}
              width='100%'
            >
              <i className='fa fa-check' />
              Confirm
            </Button>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button
              onClick={() => DeckUI.showCloseModal = false}
              background={Theme.red}
              width='100%'
            >
              <i className='fa fa-times' />
              Cancel
            </Button>
          </ButtonWrapper>
        </ButtonGroup>
        <CheckboxRow>
          <Checkbox
            value={this.state.disableFutureConfirmation}
            onClick={this.onToggleDisableFutureConfirmation}
            margin='0 10px 0 0'
          />
          <CheckboxLabel
            onClick={this.onToggleDisableFutureConfirmation}
          >
            <Text
              fontSize='14px'
            >
              Don't ask me again
            </Text>
          </CheckboxLabel>
        </CheckboxRow>
      </Wrapper>
    );
  }
}

export default DeckCloseWebWrapper(DeckClose);
